var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('icon-button',{staticClass:"w-5 h-5 m-auto cursor-pointer play-btn",class:{
            'ar-player__play--active': _vm.isPlaying,
            'play-bg': _vm.iconBackground && !_vm.isPlaying,
            'pause-bg': _vm.iconBackground && _vm.isPlaying
        },attrs:{"name":_vm.playBtnIcon,"iconBackground":_vm.iconBackground},nativeOn:{"click":function($event){return _vm.playback.apply(null, arguments)}}}),_vm._v(" "),_c('audio',{staticClass:"hidden",attrs:{"id":_vm.playerUniqId,"src":_vm.audioSource,"preload":"auto","controls":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }